module.exports = __webpack_public_path__ + "img/video-cover.09deb2ce.png";